module.exports = "/images/sd.svg?98b1567482e806b8be05d22ae6e69629";